var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrenada(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.713 44.522C152.798 16.436 202.476 0 256 0C309.524 0 359.202 16.436 400.287 44.522L256 55.652L111.713 44.522Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 256L239.662 239.662L235.324 247.433L256 256Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9795 74.98C-24.9945 174.954 -24.9945 337.045 74.9795 437.02C116.293 395.707 156.026 355.974 256 256L74.9795 74.98Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.02 74.98C536.994 174.954 536.994 337.045 437.02 437.02C395.707 395.707 355.974 355.974 256 256L437.02 74.98Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 345.043C305.177 345.043 345.043 305.177 345.043 256C345.043 206.823 305.177 166.957 256 166.957C206.823 166.957 166.957 206.823 166.957 256C166.957 305.177 206.823 345.043 256 345.043Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.999 166.957L275.958 228.386H340.556L288.298 266.359L308.257 327.791L255.999 289.825L203.739 327.791L223.702 266.359L171.444 228.386H236.038L255.999 166.957Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 0C255.971 0 255.943 0.002 255.914 0.002H256.085C256.057 0.002 256.029 0 256 0V0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.086 0H255.915C185.262 0.023 121.301 28.666 74.9941 74.968H437.007C390.699 28.666 326.738 0.023 256.086 0Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9951 437.033C121.321 483.352 185.315 512 256 512C326.685 512 390.679 483.352 437.005 437.033H74.9951Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 27.826L260.145 40.5801H273.555L262.706 48.4631L266.851 61.217L256 53.335L245.151 61.217L249.296 48.4631L238.445 40.5801H251.855L256 27.826Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.923 27.826L198.068 40.5801H211.478L200.629 48.4631L204.774 61.217L193.923 53.335L183.075 61.217L187.219 48.4631L176.368 40.5801H189.778L193.923 27.826Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.077 27.826L322.222 40.5801H335.632L324.783 48.4631L328.928 61.217L318.077 53.335L307.228 61.217L311.373 48.4631L300.522 40.5801H313.932L318.077 27.826Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 450.783L260.145 463.537H273.555L262.706 471.42L266.851 484.174L256 476.291L245.151 484.174L249.296 471.42L238.445 463.537H251.855L256 450.783Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.923 450.783L198.068 463.537H211.478L200.629 471.42L204.774 484.174L193.923 476.291L183.075 484.174L187.219 471.42L176.368 463.537H189.778L193.923 450.783Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.077 450.783L322.222 463.537H335.632L324.783 471.42L328.928 484.174L318.077 476.291L307.228 484.174L311.373 471.42L300.522 463.537H313.932L318.077 450.783Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.003 251.772C84.578 262.161 81.488 275.912 71.099 282.488C60.711 289.064 46.959 285.974 40.383 275.585C28.478 256.777 35.381 226.06 35.381 226.06C35.381 226.06 66.097 232.963 78.003 251.772V251.772Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1456 284.215C71.2926 284.215 76.2756 279.232 76.2756 273.085C76.2756 266.938 71.2926 261.955 65.1456 261.955C58.9987 261.955 54.0156 266.938 54.0156 273.085C54.0156 279.232 58.9987 284.215 65.1456 284.215Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrenada);
export default __webpack_public_path__ + "static/media/grenada.c7a35061ffb4f787dd677629fe9577dd.svg";
export { ForwardRef as ReactComponent };